import axios from 'axios'

axios.defaults.withCredentials = true

const state = {
  authenticated: false,
  position: 'NA',
  name: '',
  branch: '',
  branch_address: 'NA',
  branch_contact_no: 'NA',
  branch_id: 0,
  district_id: 0,
  district_name: '',
  month_of: 'NA',
  id_no: 0,
  teller_already_cut_off: false,
  can_new_month: false,
  user_id: 0,
  merchant_id: 0,
  member_id: 0,

  year: 'NA',
  month_start: 0,
  month_end: 'NA',
}

const mutations = {
  set_authenticated(state, authenticated) {
    state.authenticated = authenticated
  },
  set_position(state, position) {
    state.position = position
  },
  set_branch_id(state, branch_id) {
    state.branch_id = branch_id
  },
  set_month_of(state, month_of) {
    state.month_of = month_of
  },
  set_id_no(state, id_no) {
    state.id_no = id_no
  },
  set_teller_already_cut_off(state, teller_already_cut_off) {
    state.teller_already_cut_off = teller_already_cut_off
  },
  set_name(state, name) {
    state.name = name
  },
  set_branch(state, branch) {
    state.branch = branch
  },
  set_can_new_month(state, can_new_month) {
    state.can_new_month = can_new_month
  },
  set_user_id(state, user_id) {
    state.user_id = user_id
  },
  set_merchant_id(state, merchant_id) {
    state.merchant_id = merchant_id
  },
  set_member_id(state, member_id) {
    state.member_id = member_id
  },
  set_branch_address(state, branch_address) {
    state.branch_address = branch_address
  },
  set_branch_contact_no(state, branch_contact_no) {
    state.branch_contact_no = branch_contact_no
  },

  set_district_id(state, district_id) {
    state.district_id = district_id
  },
  set_district_name(state, district_name) {
    state.district_name = district_name
  },
  set_month_start(state, month_start) {
    state.month_start = month_start
  },
  set_month_end(state, month_end) {
    state.month_end = month_end
  },
}

const getters = {
  authenticated: state => state.authenticated,
  position: state => state.position,
  branch_id: state => state.branch_id,
  branch_address: state => state.branch_address,
  branch_contact_no: state => state.branch_contact_no,
  month_of: state => state.month_of,
  teller_already_cut_off: state => state.teller_already_cut_off,
  id_no: state => state.id_no,
  name: state => state.name,
  branch: state => state.branch,
  can_new_month: state => state.can_new_month,
  user_id: state => state.user_id,
  merchant_id: state => state.merchant_id,
  member_id: state => state.member_id,
  district_id: state => state.district_id,
  district_name: state => state.district_name,

  month_start: state => state.month_start,
  month_end: state => state.month_end,
}

const actions = {
  change_month: ({commit}, month_of) => {
    commit('set_month_of', month_of)
  },
  change_branch_id: ({commit}, data) => {
    commit('set_branch_id', data.id)
    commit('set_branch', data.branch_code)
    commit('set_branch_address', data.address)
    commit('set_branch_contact_no', data.contact_no)

    commit('can_new_month', data.can_new_month)
    commit('set_month_of', data.transaction_month.month_of)
    commit('set_year', data.transaction_month.year)
    commit('set_month_start', data.transaction_month.month_start)
    commit('set_month_end', data.transaction_month.month_end)
  },
  change_teller_already_cut_off: ({commit}, teller_already_cut_off) => {
    commit('set_teller_already_cut_off', teller_already_cut_off)
  },
  change_can_new_month: ({commit}, can_new_month) => {
    commit('set_can_new_month', can_new_month)
  },
  login_credentials({commit, rootGetters}, data) {
    axios.defaults.baseURL = rootGetters['system_data/url']
    return new Promise((resolve, reject) => {
      axios.get('/sanctum/csrf-cookie').then(() => {
          axios.post('api/login-user-profile', data)
            .then(response => {
              if (response.data === 'The provided USER INFO are incorrect.'
                || response.data === 'The USER is already Login') {
                commit('set_authenticated', false)
              } else {
                commit('set_authenticated', true)

                commit('set_user_id', response.data.id)
                commit('set_merchant_id', response.data.merchant_id)
                commit('set_member_id', response.data.member_id)
                commit('set_name', response.data.name)
                commit('set_branch', response.data.branch.branch_code)
                commit('set_id_no', response.data.id_no)
                commit('set_position', response.data.positions)

                commit('set_branch_id', response.data.branch_id)
                commit('set_branch', response.data.branch.branch_code)
                commit('set_branch_address', response.data.branch.address)
                commit('set_branch_contact_no', response.data.branch.contact_no)
                commit('set_month_start', response.data.branch.transaction_month.month_start)
                commit('set_month_end', response.data.branch.transaction_month.month_end)

                commit('set_district_id', response.data.district_id)
                commit('set_district_name', '')
                if (response.data.district_id != null) {
                  commit('set_district_name', response.data.district.district_name)
                }
              }
              resolve(response)
            })
            .catch((error) => {
              reject(error)
            })
        }
      )
        .catch((error) => {
          reject(error)
        })
    })
  },
  logout_credentials({commit, rootGetters}, data) {
    axios.defaults.baseURL = rootGetters['system_data/url']
    return new Promise((resolve, reject) => {
      axios.post('api/logout-user-profile', data)
        .then(response => {
          commit('set_authenticated', false)
          commit('set_position', 'NA')

          commit('set_branch_id', 0)
          commit('set_branch', 'NA')
          commit('set_branch_address', 'NA')
          commit('set_branch_contact_no', 'NA')

          commit('set_month_of', 'NA')
          commit('set_teller_already_cut_off', false)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations
}
